<script>
  import { fade, fly } from "svelte/transition";
  import { onMount } from "svelte";

  let onLoad = false;

  onMount(() => {
    setTimeout(() => (onLoad = true), 50);
  });
</script>

<style>
  .social {
    display: flex;
    justify-content: center;
    width: 100%;
    -webkit-animation: delayedFadeInFromNone 3.5s ease-out;
    -moz-animation: delayedFadeInFromNone 3.5s ease-out;
    -o-animation: delayedFadeInFromNone 3.5s ease-out;
    animation: delayedFadeInFromNone 3.5s ease-out;
  }
  .social__link {
    padding: 0.7em;
    transition: all 0.3s ease-in-out;
  }
  .social__link,
  .social__link img {
    width: 50px;
    height: 50px;
  }
  .zoom {    
    transition: transform .5s;    
  }

  .zoom:hover {
    transform: scale(1.15);
    opacity: 80%;
  }
</style>

{#if onLoad}
  <div class="social" in:fly={{ y: 50, duration: 2000 }}>
    <a
      class="social__link zoom"
      href="https://github.com/bugraoguzhanyildiz"
      target="_blank">
      <img src="./assets/github.png"/>
    </a>
    <a
      class="social__link zoom"
      href="https://www.linkedin.com/in/bugraoguzhanyildiz/"
      target="_blank">
      <img src="./assets/linkedin.png" />
    </a>
    <a
      class="social__link zoom"
      href="https://twitter.com/ouzhnnn"
      target="_blank">
      <img src="./assets/twitter.png" />
    </a>
    <a class="social__link zoom" href="https://medium.com/@bugraoguzhanyildiz" target="_blank">
      <img src="./assets/medium.png" />
    </a>
    <a class="social__link zoom" href="https://marketplace.visualstudio.com/publishers/oguzhanyildiz" target="_blank">
      <img src="./assets/vs.png" />
    </a>    
  </div>
{/if}
